import { Route, NavigationGuardNext } from "vue-router";

import AcceptPage from "./components/AcceptPage.vue";
import RejectPage from "./components/RejectPage.vue";
import RejectSuccessPage from "./components/RejectSuccessPage.vue";
import AcceptSuccessPage from "./components/AcceptSuccessPage.vue";
import PreviewUnavailablePage from "./components/PreviewUnavailablePage.vue";

import customerPreviewGuard from "./customer-preview-guard.function";

export default [
  {
    path: "/preview/accept",
    name: "AcceptPage",
    component: AcceptPage,
    props: (route: Route) => {
      return {
        plushieId: route.query.plushieId,
      };
    },
    meta: {
      auth: true,
    },
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
      void customerPreviewGuard(to, from, next);
    },
  },
  {
    path: "/preview/reject",
    name: "RejectPage",
    component: RejectPage,
    props: (route: Route) => {
      return {
        plushieId: route.query.plushieId,
      };
    },
    meta: {
      auth: true,
    },
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
      void customerPreviewGuard(to, from, next);
    },
  },
  {
    path: "/preview/reject_success",
    name: "RejectSuccessPage",
    component: RejectSuccessPage,
    props: (route: Route) => {
      return {
        plushieId: route.query.plushieId,
      };
    },
    meta: {
      auth: true,
    },
  },
  {
    path: "/preview/accept_success",
    name: "AcceptSuccessPage",
    component: AcceptSuccessPage,
    props: (route: Route) => {
      return {
        plushieId: route.query.plushieId,
      };
    },
    meta: {
      auth: true,
    },
  },
  {
    path: "/preview/unavailable",
    name: "PreviewUnavailablePage",
    component: PreviewUnavailablePage,
    meta: {
      auth: true,
    },
  },
];
